export const DEFAULT_EXIT_ICON_ARIA_LABEL = 'Close modal';
export const BUTTONS_SIZE_VARIANT = 'large';
export const BUTTON_AS = 'button';
export const ACCEPT_BUTTON_VARIANT = 'primary';
export const DISMISS_BUTTON_VARIANT = 'secondary';
export const MODAL_TITLE = 'Are You Sure?';
export const MODAL_DESCRIPTION =
  'Are you sure you want to leave? You will lose any edits or changes that you made.';
export const MODAL_LABELLED_BY = 'confirmationAuctionTitle';
export const MODAL_DESCRIBED_BY = 'confirmationAuctionDescription';
export const MODAL_CANCEL_TEXT = 'Leave';
export const MODAL_ACCEPT_TEXT = 'Stay';
export const DRAWER_ROLE = 'dialog';
export const ARIA_MODAL = 'true';
export const SUBMIT_TYPE = 'submit';
export const FORM_ID = 'auctionItemForm';
export const TITLE_ID = 'auctionItemDrawer';
export const TEXT_AS = 'h1';
